import React from 'react'
import { useQuery } from 'react-query'
import Fetcher from '../../../hoc/FetcherSetting/FetcherSetting'
import { useParams } from 'react-router'
import { useHistory } from "react-router-dom";
import moment from 'moment';

function ViewCorrectiveActionReport() {
    const { orgcode } = useParams()
    const { data: auditdata, isLoading } = useQuery(
        'listrfq',
        () => Fetcher('get', '/api/stagetwo/get/stagetwodata/' + orgcode, {}))
        console.log("view data cor",auditdata)
    const history = useHistory();

    const handleRoute = () => {
      
        window.location.href="/"+localStorage.getItem("role")+'/correctiveactionreport/' + orgcode
    }
    

    if (isLoading) return <h1>Loading</h1>
    return (
        <div>
              <div className="content-wrapper">
                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="card-body" style={{ paddingLeft: "4%" , paddingRight:"4%"}}>
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <form>
                                                    <div className="row">
                                                        <label htmlFor="staticEmail" className="col-sm-3 labelsize">Client Name</label>
                                                        <div className="col-sm-9">
                                                        <p> {auditdata.data.response.orgName}</p>
                                                        </div>
                                                        </div>

                                                    <div className="row mt-4">
                                                        <label htmlFor="staticEmail" className="col-sm-3 labelsize">Location</label>
                                                        <div className="col-sm-9">
                                                        <p> {auditdata.data.response.address}</p>
                                                        </div>
                                                     
                                                    </div>

                                                    <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Audit Date(s)</label>
                                                        <div className="col-sm-3">
                                                        <p> { moment(auditdata.data.response.dateofaudit).format("DD-MMM-YYYY")}</p>
                                                        </div>
                                                        <label htmlFor="staticEmail" className="col-sm-3 labelsize">Lead Auditor</label>
                                                        <div className="col-sm-3">
                                                        <p> {auditdata.data.response.teamleaderName}</p>
                                                    
                                                        </div>
                                                       
                                                       
                                                    </div>
                                                    <div className="row mt-4">
                                                   <label htmlFor="staticEmail" className="col-sm-8 labelsize">Audit #: Initial(Stage 1/Stage 2)/Surveillance/ Recertification Audit/ Special Audit/ FollowupProcess Area:</label>
                                                        <div className="col-sm-3">
                                                        <p>  {auditdata.data.response.initialaudit}</p>
                                                          
                                                        </div>
                                                        </div>
                                                        <div className="row mt-4">
                                                    <div className="col-lg-12 col-lg-offset-1">
                                                        <table className="table table-bordered table-striped" >
                                                            <thead className="table-primary">
                                                                <tr>
                                                                    <th scope="col" className="text-center" style={{ "width": "100px" }}>#</th>
                                                                    <th scope="col" className="text-center">Nonconformity</th>
                                                                    <th scope="col" className="text-center">Clause No</th>
                                                                    <th scope="col" className="text-center">CAR No</th>
                                                                    <th scope="col" className="text-center">Category </th>
                                                                    <th scope="col" className="text-center">Respond By (Auditee)</th>
                                                                    <th scope="col" className="text-center">Complete Corrective Action By</th>
                                                                    <th scope="col" className="text-center">Root Cause</th>
                                                                    <th scope="col" className="text-center">Correction</th>
                                                                    <th scope="col" className="text-center">Corrective Action Implenmented</th>

                                                                   
                                                               
                                                                </tr>
                                                            </thead>
                                                            <tbody >
                                                                {
                                                                  auditdata && auditdata.data.response && auditdata.data.response.correctiveDetails && auditdata.data.response.correctiveDetails.length && auditdata.data.response.correctiveDetails.length >0 ?
                                                                  auditdata.data.response.correctiveDetails.map((item, index) => {
                                                                        return (
                                                                            <tr key={index}>
                                                                              
                                                                                <td className="text-center">{index + 1}</td>
                                                                                <td className="text-center">{item.nonconformity}</td>
                                                                                <td className="text-center">{item.clauseno}</td>
                                                                                <td className="text-center">{item.carno}</td>
                                                                                <td>{item.category}</td>
                                                                                <td>{item.respondaudtee}</td>
                                                                                <td>{item.completecorrective}</td>
                                                                                <td>{item.rootcause}</td>
                                                                                 <td>{item.correction}</td> 
                                                                                 <td>{item.correctiveactImp}</td>
                                                                                 
                                                                            </tr>
                                                                        )
                                                                    })
                                                                    :
                                                                    <p>No Correctiv eDetails have been added yet </p>
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    </div>

                                                    

                                                    <div className="row mt-4">
                                                        
                                                        <label htmlFor="staticEmail" className="col-sm-3 labelsize">Date</label>
                                                        <div className="col-sm-3">
                                                        <p> {moment(auditdata.data.response.date).format("DD-MMM-YYYY")}</p>
                                                        
                                                        </div>
                                                    </div>
                                                    <hr />
                                                    <div className="row ">
                                                            <div className="hrstyle headingcolor">
                                                                <h5 className="mb-3">IQCPL use only</h5>
                                                            </div>
                                                        </div>
                                                        <hr/>
                                                        <div className="row">
                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Effectiveness of CA verified:</label>
                                                            <div className="col-sm-3">
                                                            { 
                                                            auditdata && auditdata.data.response && auditdata.data.response.effectivenessca &&
                                                            auditdata.data.response.effectivenessca.map((item, index) => {
                                                                        return (
                                                                            <div key={index} >{item} </div>
                                                                             
                                                                            )
                                                                        })
                                                                        
                                                                    }
                                                           
                                                            </div>
                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Non Conformity:</label>
                                                        <div className="col-sm-3">
                                                        { 
                                                            auditdata && auditdata.data.response && auditdata.data.response.nonconformity &&
                                                            auditdata.data.response.nonconformity.map((item, index) => {
                                                                        return (
                                                                            <div key={index} >{item} </div>
                                                                             
                                                                            )
                                                                        })
                                                                        
                                                                    }
                                                        </div>
                                                        </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    { 
                    localStorage.getItem("userRole")==="Management" || localStorage.getItem("userRole")==="Accounts"   ?
                    ""
                    :
                    <div className="card-footer">
                    <div className="row">
                    <div className="col-lg-11"></div>
                    <div className="col-lg-1" style={{ marginBottom: "10PX" }}>

                        <button type="submit" className="btn btn-primary" onClick={handleRoute}>Edit</button>

                    </div>
                    </div>
                </div>
                }
        
                </div>
        </div>
    )
}

export default ViewCorrectiveActionReport
